import { useEffect, useState } from "react"
import {
  ResourcesFragment,
  useGetOrgInAppResourcesQuery,
  useGetAllInAppResourcesQuery,
} from "../generated/graphql"
import { InAppResourcesTableData } from "../utils/types"
import { useGraphQLClient } from "./useGraphQLClient"
import { useUser } from "./useUser"
import { dummyResource } from "../utils/helpers"
export const useInAppResources = (orgId: number) => {
  const { user } = useUser()
  const [inAppResources, setInAppResources] = useState<
    InAppResourcesTableData[]
  >([])
  const graphQLClient = useGraphQLClient()
  const { data: contentData, refetch: refetchOrgResources } =
    useGetOrgInAppResourcesQuery(graphQLClient, {
      org_id: orgId,
    })
  const { data: allData, refetch: refetchAllResources } =
    useGetAllInAppResourcesQuery(graphQLClient)

  const processResourceData = (
    resources: ResourcesFragment[]
  ): InAppResourcesTableData[] => {
    const convertedResources: InAppResourcesTableData[] = []
    resources.forEach((resource: ResourcesFragment) => {
      //only show articles
      const title = resource.title
      const created_on = resource.created_on
      const author = resource.author
      const id = resource.id
      const content = resource.content
      const content_type = resource.content_type
      const header_image = resource.header_image
      const owner_org_id = resource.owner_org_id
      const updated_on = resource.updated_on
      const created_by = resource.created_by
      const publicAccess = resource.public
      const data: InAppResourcesTableData = {
        id: {
          sortData: id,
          data: id,
        },
        title: {
          sortData: title,
          data: title,
        },
        created_on: {
          sortData: created_on,
          data: created_on,
        },
        author: {
          sortData: author,
          data: author,
        },
        content: {
          sortData: content,
          data: content,
        },
        content_type: {
          sortData: content_type,
          data: content_type,
        },
        owner_org_id: {
          sortData: owner_org_id,
          data: owner_org_id,
        },
        updated_on: {
          sortData: updated_on,
          data: updated_on,
        },
        created_by: {
          sortData: created_by,
          data: created_by,
        },
        public: {
          sortData: publicAccess,
          data: publicAccess,
        },
        header_image: {
          sortData: header_image,
          data: header_image,
        },
        more: {
          sortData: "",
          data: {},
        },
      }
      convertedResources.push(data)
    })
    convertedResources.push({ ...dummyResource }) // placeholder for dropdown
    return convertedResources
  }
  useEffect(() => {
    if (!user) return
    if (user && user.email?.endsWith("@ksanahealth.com")) {
      const resources = processResourceData(allData?.resources || [])
      setInAppResources(resources)
    } else {
      const resources = processResourceData(contentData?.resources || [])
      setInAppResources(resources)
    }
  }, [setInAppResources, contentData?.resources, allData?.resources, user])

  return { inAppResources, refetchAllResources, refetchOrgResources }
}
